// @flow
import React, { Component } from 'react'
import styled, { type StyledComponent } from 'styled-components'
import _ from 'lodash'

const Wrapper: StyledComponent<Object, any, any> = styled.div`
  ${({ marginLeft }) => (marginLeft ? 'margin-left: 100px;' : '')} padding: 4px 0;
  color: red;
  font-size: 14px;
`

type Props = {|
  errors: ?Array<string>,
  marginLeft?: boolean
|}

export default class ErrorText extends Component<Props> {
  render() {
    const { marginLeft, errors } = this.props

    if (_.isEmpty(errors)) return null

    return (
      <Wrapper className="t-ErrorText" marginLeft={marginLeft}>
        {_.map(_.isArray(errors) ? errors : [errors], (error, index: number) => (
          <div key={index}>{error}</div>
        ))}
      </Wrapper>
    )
  }
}
